var map = {
	"./404.md": 510,
	"./_template.jsx": 387,
	"./articles/2016-08-13-the-skinny-suit/index.md": 511,
	"./articles/2016-10-23-one/index.md": 512,
	"./articles/2016-11-12-attention-is-love/index.md": 513,
	"./articles/2016-11-14-shipping-is-an-act-of-kindness/index.md": 514,
	"./articles/2016-11-15-on-publishing-our-work/index.md": 515,
	"./articles/2016-11-17-bringing-an-idea-to-life/index.md": 516,
	"./articles/2016-11-18-a-new-day/index.md": 517,
	"./articles/2016-11-19-courage/index.md": 518,
	"./articles/2016-11-23-speak-up/index.md": 519,
	"./articles/2016-11-25-a-good-question/index.md": 520,
	"./articles/2016-11-26-key-advantages-in-an-ai-world/index.md": 521,
	"./articles/2017-02-06-the-path/index.md": 522,
	"./articles/2017-04-13-between-stimulus-and-response/index.md": 523,
	"./articles/2017-05-11-on-being-yourself/index.md": 524,
	"./articles/2017-08-16-cant-tell-you-why/index.md": 525,
	"./articles/2017-09-15-a-gentle-reminder/index.md": 526,
	"./articles/2017-09-16-always/index.md": 527,
	"./articles/2017-10-6-at-the-same-time/index.md": 528,
	"./index.jsx": 529,
	"./pages/blog/index.md": 530,
	"./pages/colors/index.md": 531,
	"./pages/contact/index.md": 532,
	"./pages/friends/index.md": 533,
	"./pages/gaming/index.md": 534,
	"./pages/now/index.md": 535,
	"./pages/reading/index.md": 536,
	"./pages/work/index.md": 537
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 509;



//////////////////
// WEBPACK FOOTER
// . (coffee|cjsx|ts|tsx|jsx|js|md|rmd|mkdn?|mdwn|mdown|markdown|litcoffee|ipynb|html|json|yaml|toml)$
// module id = 509
// module chunks = 0